import React, { useState, useEffect } from 'react';
import AddContractDraftForm from './AddContractDraftForm'; // Zmieniono nazwę importu
import projectService from '../../services/projectService'; // Dodano import serwisu
import {
  Box,
  Typography,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  IconButton,
  Menu,
  MenuItem
} from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { CircularProgress } from '@mui/material'; // Dodano CircularProgress

// Definicja interfejsu dla draftu umowy (powinna pasować do danych z backendu)
export interface ContractDraftDisplay {
  id: number; // Zmieniono z string na number, jeśli ID jest numeryczne
  contract_number: string;
  subcontractor_name: string;
  project_id: string; // lub number, zależnie od tego co zwraca backend dla project.project_id
  package_id?: string; // Opcjonalne, jeśli nie zawsze jest powiązane z pakietem
  order_name: string; // Przedmiot umowy
  net_renumeration: number;
  google_doc_template_url?: string; // Link do wygenerowanego dokumentu
  status: string;
  createdAt?: string;
  updatedAt?: string;
  project?: { // Opcjonalne dane projektu, jeśli są dołączane
    project_id: string;
    project_name: string;
  };
  // Można dodać więcej pól, jeśli są potrzebne
}


interface DraftyUmowTabProps {
  projectName: string;
  projectId: string; // Dodano projectId
}

const DraftyUmowTab: React.FC<DraftyUmowTabProps> = ({ projectName, projectId }) => {
  const [drafty, setDrafty] = useState<ContractDraftDisplay[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [openAddDraftForm, setOpenAddDraftForm] = useState(false); // Zmieniono nazwę dla jasności
  // const [editMode, setEditMode] = useState(false); // Na razie pomijamy edycję
  // const [selectedDraft, setSelectedDraft] = useState<ContractDraftDisplay | null>(null); // Na razie pomijamy edycję
  const [selectedDraftItems, setSelectedDraftItems] = useState<number[]>([]); // Używamy ID numerycznego
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [menuDraftId, setMenuDraftId] = useState<number | null>(null); // Przechowujemy ID draftu

  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  const fetchDrafts = () => {
    console.log(`DraftyUmowTab: fetchDrafts called for projectId: ${projectId}`);
    if (!projectId) {
        console.log("DraftyUmowTab: projectId is null or undefined, skipping fetch.");
        setDrafty([]); // Ustawiamy pustą tablicę, jeśli brak projectId
        setError(null);
        setLoading(false);
        return;
    }
    setLoading(true);
    setError(null);
    setSuccessMessage(null);
    
    console.log(`DraftyUmowTab: Starting fetch for projectId: ${projectId}`);
    
    projectService.getContractDraftsByProjectId(projectId)
      .then((list: any) => {
        const arrayData = Array.isArray(list) ? list : (list?.data || []);
        console.log(`DraftyUmowTab: Setting ${arrayData.length} drafts.`);
        setDrafty(arrayData as any);
        setError(null);
        if (arrayData.length > 0) {
          setSuccessMessage(`Pomyślnie załadowano ${arrayData.length} draftów umów.`);
          setTimeout(() => setSuccessMessage(null), 3000);
        }
      })
      .catch((err: any) => {
        console.error("DraftyUmowTab: Błąd podczas pobierania draftów umów:", err);
        setError(err?.message || "Nie udało się załadować draftów umów.");
        setDrafty([]);
      })
      .finally(() => {
        console.log("DraftyUmowTab: Fetch finished.");
        setLoading(false);
      });
  };

  useEffect(() => {
    console.log(`DraftyUmowTab: useEffect triggered. projectId: ${projectId}`);
    fetchDrafts();
  }, [projectId]); // Zależność od projectId

  const handleOpenAddDraftForm = () => {
    // setEditMode(false);
    // setSelectedDraft(null);
    setOpenAddDraftForm(true);
  };

  const handleCloseAddDraftForm = () => {
    setOpenAddDraftForm(false);
    // setEditMode(false);
    // setSelectedDraft(null);
  };

  const handleDraftAdded = () => {
    fetchDrafts(); // Odśwież listę po dodaniu nowego draftu
  };

  // Poniższe funkcje na razie zostawiamy uproszczone lub zakomentowane
  // const handleOpenEditDraftForm = () => { ... };
  // const handleEditDraft = (editedDraft: any) => { ... };
  // const handleDeleteDraft = (draftId: number) => { ... };

  const handleSelectDraftItem = (draftId: number) => {
    const selectedIndex = selectedDraftItems.indexOf(draftId);
    let newSelected: number[] = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selectedDraftItems, draftId);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selectedDraftItems.slice(1));
    } else if (selectedIndex === selectedDraftItems.length - 1) {
      newSelected = newSelected.concat(selectedDraftItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selectedDraftItems.slice(0, selectedIndex),
        selectedDraftItems.slice(selectedIndex + 1),
      );
    }
    setSelectedDraftItems(newSelected);
  };

  const handleSelectAllDraftItems = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.checked) {
      const newSelecteds = drafty.map((d) => d.id);
      setSelectedDraftItems(newSelecteds);
      return;
    }
    setSelectedDraftItems([]);
  };

  const isDraftItemSelected = (draftId: number) => selectedDraftItems.indexOf(draftId) !== -1;

  const handleOpenMenu = (event: React.MouseEvent<HTMLElement>, draftId: number) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setMenuDraftId(draftId);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
    setMenuDraftId(null);
  };

  const handleViewDocument = () => {
    if (menuDraftId !== null) {
      const draft = drafty.find(d => d.id === menuDraftId);
      if (draft && draft.google_doc_template_url) { // Używamy google_doc_template_url jako linku do dokumentu
        window.open(draft.google_doc_template_url, '_blank');
      } else {
        console.warn("Brak linku do dokumentu dla draftu:", menuDraftId);
      }
    }
    handleCloseMenu();
  };

  const getStatusStyle = (status: string) => {
    switch (status) {
      case 'W podpisie':
        return {
          backgroundColor: '#E3F2FD',
          color: '#1976D2'
        };
      case 'Podpisana':
        return {
          backgroundColor: '#E8F5E9',
          color: '#2E7D32'
        };
      case 'Nie podpisana':
        return {
          backgroundColor: '#FFEBEE',
          color: '#C62828'
        };
      default:
        return {
          backgroundColor: '#F5F5F5',
          color: '#757575'
        };
    }
  };

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
          Drafty umów z PW (16)
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 1 }}>
          {/* Na razie ukrywamy przycisk Edytuj
          {selectedDraftItems.length > 0 && selectedDraftItems.length === 1 && (
            <Button variant="contained" onClick={handleOpenEditDraftForm} sx={{ backgroundColor: '#09C3A3', '&:hover': { backgroundColor: '#07B093' }}}>
              Edytuj
            </Button>
          )}
          */}
          <Button 
            variant="contained" 
            onClick={handleOpenAddDraftForm}
            sx={{ 
              backgroundColor: '#004273',
              '&:hover': { backgroundColor: '#003660' }
            }}
          >
            Dodaj
          </Button>
        </Box>
      </Box>
      
      {/* Komunikat o sukcesie */}
      {successMessage && (
        <Box sx={{ 
          backgroundColor: '#E8F5E9', 
          color: '#2E7D32', 
          p: 1, 
          borderRadius: 1, 
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Typography>{successMessage}</Typography>
        </Box>
      )}
      
      {/* Komunikat o błędzie */}
      {error && (
        <Box sx={{ 
          backgroundColor: '#FFEBEE', 
          color: '#C62828', 
          p: 1, 
          borderRadius: 1, 
          mb: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}>
          <Typography>{error}</Typography>
        </Box>
      )}
      
      {/* Tabela draftów umów */}
      <TableContainer component={Paper} sx={{ mt: 2, boxShadow: 'none', border: '1px solid #eee' }}>
        <Table size="small">
          <TableHead sx={{ backgroundColor: '#f5f5f5' }}>
            <TableRow>
              <TableCell padding="checkbox" width="40px">
                <Checkbox 
                  indeterminate={selectedDraftItems.length > 0 && selectedDraftItems.length < drafty.length}
                  checked={selectedDraftItems.length === drafty.length}
                  onChange={handleSelectAllDraftItems}
                />
              </TableCell>
              <TableCell width="150px">Nr umowy</TableCell>
              <TableCell>Podwykonawca</TableCell>
              <TableCell>Przedmiot umowy</TableCell>
              <TableCell width="120px">Wartość netto</TableCell>
              <TableCell width="100px">Status</TableCell>
              {/* Usunięto kolumnę Dokument */}
              <TableCell width="60px">Akcje</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={6} align="center"> {/* Zmniejszono colSpan o 1 */}
                  <CircularProgress />
                </TableCell>
              </TableRow>
            ) : error ? (
              <TableRow>
                <TableCell colSpan={6} align="center"> {/* Zmniejszono colSpan o 1 */}
                  <Typography color="error">{error}</Typography>
                </TableCell>
              </TableRow>
            ) : drafty.length === 0 ? (
                <TableRow>
                    <TableCell colSpan={6} align="center"> {/* Zmniejszono colSpan o 1 */}
                        Brak draftów umów dla tego projektu.
                    </TableCell>
                </TableRow>
            ) : (
              drafty.map((draft) => {
                const isSelected = isDraftItemSelected(draft.id);
                const statusStyle = getStatusStyle(draft.status);
                return (
                  <TableRow
                    key={draft.id}
                    hover
                    onClick={() => handleSelectDraftItem(draft.id)}
                    selected={isSelected}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox checked={isSelected} />
                    </TableCell>
                    <TableCell>{draft.contract_number}</TableCell>
                    <TableCell>{draft.subcontractor_name}</TableCell>
                    <TableCell>{draft.order_name}</TableCell>
                    <TableCell>{draft.net_renumeration.toLocaleString('pl-PL', { style: 'currency', currency: 'PLN' })}</TableCell>
                    <TableCell>
                      <Box
                        sx={{
                          backgroundColor: statusStyle.backgroundColor,
                          color: statusStyle.color,
                          borderRadius: 1,
                          px: 1,
                          py: 0.5,
                          display: 'inline-block',
                          fontSize: '0.75rem',
                          fontWeight: 'medium'
                        }}
                      >
                        {draft.status}
                      </Box>
                    </TableCell>
                    {/* Usunięto komórkę dla przycisku "Otwórz" */}
                    <TableCell>
                      <IconButton
                        size="small"
                        onClick={(e) => handleOpenMenu(e, draft.id)}
                      >
                        <MoreVertIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        MenuListProps={{
          'aria-labelledby': 'long-button',
        }}
      >
        <MenuItem onClick={() => {
          // Logika dla "Gdoc"
          if (menuDraftId !== null) {
            const draft = drafty.find(d => d.id === menuDraftId);
            if (draft && draft.google_doc_template_url) {
              window.open(draft.google_doc_template_url, '_blank');
            } else {
              console.warn("Brak linku Gdoc dla draftu:", menuDraftId);
              alert("Brak linku do dokumentu Google dla tego draftu.");
            }
          }
          handleCloseMenu();
        }}>
          Gdoc
        </MenuItem>
        <MenuItem onClick={() => {
          // Logika dla "Generuj PDF"
          if (menuDraftId !== null) {
            const draft = drafty.find(d => d.id === menuDraftId);
            if (draft && draft.id) {
              console.log("Generuj PDF dla draftu o ID:", draft.id);
              projectService.exportContractDraftToPdf(draft.id)
                .then(blob => {
                  const url = window.URL.createObjectURL(blob);
                  const a = document.createElement('a');
                  a.href = url;
                  a.download = `umowa_${draft.contract_number || draft.id}.pdf`;
                  document.body.appendChild(a);
                  a.click();
                  a.remove();
                  window.URL.revokeObjectURL(url);
                })
                .catch(err => {
                  console.error("Błąd podczas generowania PDF:", err);
                  alert(`Nie udało się wygenerować PDF: ${err.message}`);
                });
            } else {
              alert("Nie można wygenerować PDF: brak danych draftu.");
            }
          }
          handleCloseMenu();
        }}>
          Generuj PDF
        </MenuItem>
        <MenuItem onClick={async () => {
          // Logika dla "Usuń"
          if (menuDraftId !== null) {
            const draftToDelete = drafty.find(d => d.id === menuDraftId);
            if (draftToDelete) {
              const confirmDelete = window.confirm(`Czy na pewno chcesz usunąć draft umowy "${draftToDelete.contract_number}" (${draftToDelete.subcontractor_name})? Spowoduje to również usunięcie powiązanego folderu i dokumentu na Google Drive.`);
              if (confirmDelete) {
                console.log("Usuwanie draftu o ID:", menuDraftId);
                try {
                  setLoading(true);
                  const result = await projectService.deleteContractDraft(menuDraftId.toString());
                  if (result) {
                    setSuccessMessage(`Pomyślnie usunięto draft umowy ${draftToDelete.contract_number}.`);
                    // Ukryj komunikat o sukcesie po 3 sekundach
                    setTimeout(() => {
                      setSuccessMessage(null);
                    }, 3000);
                    fetchDrafts(); // Odśwież listę po usunięciu
                  } else {
                    setError("Nie udało się usunąć draftu umowy.");
                  }
                } catch (err: any) {
                  console.error("Błąd podczas usuwania draftu:", err);
                  setError(err.message || "Wystąpił błąd podczas usuwania draftu.");
                } finally {
                  setLoading(false);
                }
              }
            }
          }
          handleCloseMenu();
        }}>
          Usuń
        </MenuItem>
      </Menu>

      <AddContractDraftForm
        open={openAddDraftForm}
        onClose={handleCloseAddDraftForm}
        projectId={projectId}
        onDraftAdded={handleDraftAdded}
      />
    </Box>
  );
};

export default DraftyUmowTab;

// Funkcja pomocnicza do stylów statusu (może być przeniesiona do osobnego pliku utils)
const getStatusStyle = (status: string) => {
  switch (status.toLowerCase()) { // Używamy toLowerCase dla większej elastyczności
    case 'draft':
      return { backgroundColor: '#FFF8E1', color: '#FF8F00' }; // Jasnożółty
    case 'pending_acceptance':
      return { backgroundColor: '#E3F2FD', color: '#1976D2' }; // Jasnoniebieski
    case 'accepted':
      return { backgroundColor: '#E8F5E9', color: '#2E7D32' }; // Jasnozielony
    case 'signed':
      return { backgroundColor: '#D1C4E9', color: '#4527A0' }; // Jasnofioletowy
    case 'rejected':
      return { backgroundColor: '#FFEBEE', color: '#C62828' }; // Jasnoczerwony
    case 'cancelled':
      return { backgroundColor: '#ECEFF1', color: '#37474F' }; // Jasnoszary
    // Dodane statusy z przykładowych danych, jeśli nadal są używane
    case 'w podpisie':
        return { backgroundColor: '#E3F2FD', color: '#1976D2'};
    case 'podpisana':
        return { backgroundColor: '#E8F5E9', color: '#2E7D32'};
    case 'nie podpisana':
        return { backgroundColor: '#FFEBEE', color: '#C62828'};
    default:
      return { backgroundColor: '#F5F5F5', color: '#757575' }; // Domyślny szary
  }
};
